import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStars } from "@fortawesome/pro-regular-svg-icons/faStars";

export const defaultTranslations = {
    pluginName: "Hero",
    pluginDescription: "Add hero block",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faStars} size="3x" />,
};
